module.exports = __webpack_public_path__ + "static/media/icon-bath.085b6505.svg";